import { WEBHOOK_EVENT_IDS } from './types';

// Controls the order webhook event cards appear on the Update Webhooks page
export const WEBHOOK_EVENT_DISPLAY_ORDER: WEBHOOK_EVENT_IDS[] = [
  WEBHOOK_EVENT_IDS.TWP_TERMED_OR_RESIGNED,
  WEBHOOK_EVENT_IDS.TWP_CREATION,
  WEBHOOK_EVENT_IDS.TWP_UPDATE,
  WEBHOOK_EVENT_IDS.TWP_DECISION,
  WEBHOOK_EVENT_IDS.TWP_CORRESPONDENCE,
  WEBHOOK_EVENT_IDS.DAILY_UPDATE,
];

export const WEBHOOK_EVENT_TITLES_MAP = {
  [WEBHOOK_EVENT_IDS.TWP_TERMED_OR_RESIGNED]: 'Associate Terminated/Resigned',
  [WEBHOOK_EVENT_IDS.TWP_CREATION]: 'TWP Creation',
  [WEBHOOK_EVENT_IDS.TWP_UPDATE]: 'TWP Update',
  [WEBHOOK_EVENT_IDS.TWP_DECISION]: 'TWP Decision (AUSTIN Only)',
  [WEBHOOK_EVENT_IDS.TWP_CORRESPONDENCE]: 'TWP Correspondence (AUSTIN Only)',
  [WEBHOOK_EVENT_IDS.DAILY_UPDATE]: 'Daily Update',
};

export const WEBHOOK_EVENT_DESCRIPTIONS_MAP = {
  [WEBHOOK_EVENT_IDS.TWP_TERMED_OR_RESIGNED]:
    'The following <accommodation type> placement(s) have been changed to Termed/Resigned status at <sitecode>.',
  [WEBHOOK_EVENT_IDS.TWP_CREATION]: 'A placement has been created for <associate> at <sitecode> by <user>.',
  [WEBHOOK_EVENT_IDS.TWP_UPDATE]: 'A placement has been updated for <associate> at <sitecode> by <user>.',
  [WEBHOOK_EVENT_IDS.TWP_DECISION]: "A decision has been made for <associate>'s accommodation request.",
  [WEBHOOK_EVENT_IDS.TWP_CORRESPONDENCE]:
    "WHS or Ops has posted new correspondence for <associate>'s accommodation \
    request in RTW tool or Decision Hub.",
  [WEBHOOK_EVENT_IDS.DAILY_UPDATE]:
    "# Placement(s) are pending a decision and affecting your site's decision time \
    metric.",
};

export const AUSTIN_ONLY_WEBHOOK_EVENTS = [WEBHOOK_EVENT_IDS.TWP_DECISION, WEBHOOK_EVENT_IDS.TWP_CORRESPONDENCE];
